interface Config {
  mode: string
  GOKOLLAB_LOCATION_ID: string
  GOKOLLAB_DOMAIN: string
  GOKOLLAB_MOBILE_DOMAIN: string
  REST_API_URLS: string
  COMMUNITIES_SERVER_URL: string
  COMMUNITIES_SOCKETS_SERVER_URL: string
  CLIENTPORTAL_SERVER_URL: string
  GOKOLLAB_SERVER_URL: string
  MEMBERSHIPS_SERVER_URL: string

  CLIENTPORTAL_PREVIEW_URL: string
  COMMUNITIES_STORAGE_BUCKET: string
  CLIENT_PORTAL_STORAGE_BUCKET: string
  COMMUNITIES_CDN_URL: string
  CLIENT_PORTAL_CDN_URL: string
  ASSETS_DRM_BASE_URL: string
  ASSETS_DRM_PROXY_URL: string
  firebase: { [key: string]: any }
  paymentBaseUrl: string
  testPaymentsPmcId: string
  livePaymentsPmcId: string
}

let mode: 'dev' | 'staging' | 'production' | 'interop'
let GOKOLLAB_LOCATION_ID: string
let GOKOLLAB_DOMAIN: string
let GOKOLLAB_MOBILE_DOMAIN: string
let REST_API_URLS: string
let firebase: { [key: string]: any }
let COMMUNITIES_SERVER_URL: string
let COMMUNITIES_SOCKETS_SERVER_URL: string
let CLIENTPORTAL_SERVER_URL: string
let GOKOLLAB_SERVER_URL: string
let MEMBERSHIPS_SERVER_URL: string
let COMMUNITIES_STORAGE_BUCKET: string
let CLIENT_PORTAL_STORAGE_BUCKET: string
let COMMUNITIES_CDN_URL: string
let CLIENT_PORTAL_CDN_URL: string
let ASSETS_DRM_BASE_URL: string
let ASSETS_DRM_PROXY_URL: string
let paymentBaseUrl = ''
let testPaymentsPmcId: string
let livePaymentsPmcId: string

const page = JSON.parse(localStorage.getItem('event') as any)
const CLIENTPORTAL_PREVIEW_URL: string =
  import.meta.env.VITE_JS_ENV === 'development'
    ? 'http://localhost:3030'
    : `https://${page && page.domain ? page.domain : window.location.hostname}`

const firebaseStagingConfig = {
  apiKey: 'AIzaSyA13JFKiF1yQV3GspdaYQ7FWOh8JRrAmU4',
  authDomain: 'highlevel-staging.firebaseapp.com',
  databaseURL: 'https://highlevel-staging.firebaseio.com',
  projectId: 'highlevel-staging',
  storageBucket: 'highlevel-staging.appspot.com',
  messagingSenderId: '85350210461',
  appId: '1:85350210461:web:d3728d34bf8bd6b5',
  cdnUrl: 'https://staging.cdn.apisystem.tech',
  assetsUrl: 'https://staging.cdn.apisystem.tech',
  oldCdnUrl: 'https://staging.cdn.msgsndr.com',
  membershipCdnUrl: 'https://staging.cdnmembership.apisystem.tech',
  communitiesCdnUrl: 'https://staging.cdncommunities.apisystem.tech',
  clientPortalCdnUrl: 'https://staging.cdnclientportal.apisystem.tech',
  membershipStorageBucket: 'revex-membership-staging',
}
const firebaseProductionConfig = {
  apiKey: 'AIzaSyB_w3vXmsI7WeQtrIOkjR6xTRVN5uOieiE',
  authDomain: 'highlevel-backend.firebaseapp.com',
  databaseURL: 'https://highlevel-backend.firebaseio.com',
  projectId: 'highlevel-backend',
  storageBucket: 'highlevel-backend.appspot.com',
  messagingSenderId: '439472444885',
  cdnUrl: 'https://cdn.apisystem.tech',
  assetsUrl: 'https://staging.cdn.apisystem.tech',
  oldCdnUrl: 'https://cdn.msgsndr.com',
  membershipCdnUrl: 'https://cdn.courses.apisystem.tech',
  membershipStorageBucket: 'revex-membership-production',
}
if (import.meta.env.VITE_JS_ENV === 'development') {
  mode = 'dev'
  GOKOLLAB_DOMAIN = 'staging.gokollab.com'
  GOKOLLAB_MOBILE_DOMAIN = 'staging.m.gokollab.com'
  REST_API_URLS = 'https://staging.services.leadconnectorhq.com'
  GOKOLLAB_LOCATION_ID = 'bb1S8LPFpG3PEWJBMaNm'
  GOKOLLAB_SERVER_URL = 'http://localhost:5501/gokollab'
  REST_API_URLS = 'https://staging.services.leadconnectorhq.com'
  COMMUNITIES_SERVER_URL = 'http://localhost:8000/communities'
  COMMUNITIES_SOCKETS_SERVER_URL =
    'https://staging.services.leadconnectorhq.com'
  CLIENTPORTAL_SERVER_URL =
    'https://staging.services.leadconnectorhq.com/clientclub'
  MEMBERSHIPS_SERVER_URL =
    'https://staging.services.leadconnectorhq.com/membership'
  COMMUNITIES_STORAGE_BUCKET = 'revex-communities-staging'
  CLIENT_PORTAL_STORAGE_BUCKET = 'revex-client-portal-staging'
  COMMUNITIES_CDN_URL = 'https://staging.cdncommunities.apisystem.tech'
  CLIENT_PORTAL_CDN_URL = 'https://staging.cdnclientportal.apisystem.tech'
  ASSETS_DRM_BASE_URL = 'https://staging.assetsdrm.clientclub.net/images'
  ASSETS_DRM_PROXY_URL =
    'https://staging.services.leadconnectorhq.com/assets-drm/assets/proxy'
  firebase = firebaseStagingConfig
  paymentBaseUrl = 'https://staging.services.leadconnectorhq.com/payments'
  testPaymentsPmcId = 'pmc_1Qoe3DFpU9DlKp7RCIeNdgoK'
  livePaymentsPmcId = 'pmc_1QwcZcFpU9DlKp7RZMEJf0m9'

  if (import.meta.env.VITE_JS_IS_GOKOLLAB) {
    GOKOLLAB_SERVER_URL = 'http://localhost:5501/gokollab'
    COMMUNITIES_SERVER_URL = 'http://localhost:5501/communities'
  }
} else if (import.meta.env.VITE_JS_ENV === 'staging') {
  mode = 'staging'
  GOKOLLAB_DOMAIN = 'staging.gokollab.com'
  GOKOLLAB_MOBILE_DOMAIN = 'staging.m.gokollab.com'
  REST_API_URLS = 'https://staging.services.leadconnectorhq.com'
  GOKOLLAB_LOCATION_ID = 'bb1S8LPFpG3PEWJBMaNm'
  COMMUNITIES_SERVER_URL =
    'https://staging.services.leadconnectorhq.com/communities'
  COMMUNITIES_SOCKETS_SERVER_URL =
    'https://staging.services.leadconnectorhq.com'
  CLIENTPORTAL_SERVER_URL =
    'https://staging.services.leadconnectorhq.com/clientclub'
  GOKOLLAB_SERVER_URL = 'https://staging.services.leadconnectorhq.com/gokollab'
  MEMBERSHIPS_SERVER_URL =
    'https://staging.services.leadconnectorhq.com/membership'
  COMMUNITIES_STORAGE_BUCKET = 'revex-communities-staging'
  CLIENT_PORTAL_STORAGE_BUCKET = 'revex-client-portal-staging'
  COMMUNITIES_CDN_URL = 'https://staging.cdncommunities.apisystem.tech'
  CLIENT_PORTAL_CDN_URL = 'https://staging.cdnclientportal.apisystem.tech'
  ASSETS_DRM_BASE_URL = 'https://staging.assetsdrm.clientclub.net/images'
  ASSETS_DRM_PROXY_URL =
    'https://staging.services.leadconnectorhq.com/assets-drm/assets/proxy'
  firebase = firebaseStagingConfig
  paymentBaseUrl = 'https://staging.services.leadconnectorhq.com/payments'
  testPaymentsPmcId = 'pmc_1Qoe3DFpU9DlKp7RCIeNdgoK'
  livePaymentsPmcId = 'pmc_1QwcZcFpU9DlKp7RZMEJf0m9'
} else if (import.meta.env.VITE_JS_ENV === 'interop') {
  mode = 'interop'
  GOKOLLAB_DOMAIN = 'interop.gokollab.com'
  GOKOLLAB_MOBILE_DOMAIN = 'interop.m.gokollab.com'
  REST_API_URLS = 'https://interop.services.leadconnectorhq.com'
  GOKOLLAB_LOCATION_ID = 'bb1S8LPFpG3PEWJBMaNm'
  MEMBERSHIPS_SERVER_URL =
    'https://interop.services.leadconnectorhq.com/membership'
  COMMUNITIES_SERVER_URL =
    'https://interop.services.leadconnectorhq.com/communities'
  COMMUNITIES_SOCKETS_SERVER_URL =
    'https://interop.services.leadconnectorhq.com'
  MEMBERSHIPS_SERVER_URL =
    'https://interop.services.leadconnectorhq.com/membership'
  CLIENTPORTAL_SERVER_URL =
    'https://interop.services.leadconnectorhq.com/clientclub'
  GOKOLLAB_SERVER_URL = 'https://interop.services.leadconnectorhq.com/gokollab'
  MEMBERSHIPS_SERVER_URL =
    'https://interop.services.leadconnectorhq.com/membership'
  COMMUNITIES_STORAGE_BUCKET = 'revex-communities-staging'
  CLIENT_PORTAL_STORAGE_BUCKET = 'revex-client-portal-staging'
  COMMUNITIES_CDN_URL = 'https://interop.cdncommunities.apisystem.tech'
  CLIENT_PORTAL_CDN_URL = 'https://interop.cdnclientportal.apisystem.tech'
  ASSETS_DRM_BASE_URL = 'https://staging.assetsdrm.clientclub.net/images'
  ASSETS_DRM_PROXY_URL =
    'https://interop.services.leadconnectorhq.com/assets-drm/assets/proxy'
  firebase = firebaseStagingConfig
  paymentBaseUrl = 'https://interop.services.leadconnectorhq.com/payments'
  testPaymentsPmcId = 'pmc_1Qoe3DFpU9DlKp7RCIeNdgoK'
  livePaymentsPmcId = 'pmc_1QwcZcFpU9DlKp7RZMEJf0m9'
} else {
  mode = 'production'
  GOKOLLAB_DOMAIN = 'gokollab.com'
  GOKOLLAB_MOBILE_DOMAIN = 'm.gokollab.com'
  REST_API_URLS = 'https://services.leadconnectorhq.com'
  GOKOLLAB_LOCATION_ID = 'VyoxA4YGXCZib071EFsR'
  COMMUNITIES_SERVER_URL = 'https://services.leadconnectorhq.com/communities'
  COMMUNITIES_SOCKETS_SERVER_URL = 'https://services.leadconnectorhq.com'
  CLIENTPORTAL_SERVER_URL = 'https://services.leadconnectorhq.com/clientclub'
  GOKOLLAB_SERVER_URL = 'https://services.leadconnectorhq.com/gokollab'
  MEMBERSHIPS_SERVER_URL = 'https://services.leadconnectorhq.com/membership'
  COMMUNITIES_STORAGE_BUCKET = 'revex-communities-production'
  CLIENT_PORTAL_STORAGE_BUCKET = 'revex-client-portal-production'
  COMMUNITIES_CDN_URL = 'https://cdncommunities.apisystem.tech'
  CLIENT_PORTAL_CDN_URL = 'https://cdnclientportal.apisystem.tech'
  ASSETS_DRM_BASE_URL = 'https://assetsdrm.clientclub.net/images'
  ASSETS_DRM_PROXY_URL =
    'https://services.leadconnectorhq.com/assets-drm/assets/proxy'
  firebase = firebaseProductionConfig
  paymentBaseUrl = 'https://services.leadconnectorhq.com/payments'
  testPaymentsPmcId = 'pmc_1Qoe3DFpU9DlKp7RCIeNdgoK'
  livePaymentsPmcId = 'pmc_1QwcZcFpU9DlKp7RZMEJf0m9'
}
const config: Config = {
  mode,
  REST_API_URLS,
  GOKOLLAB_LOCATION_ID,
  GOKOLLAB_DOMAIN,
  GOKOLLAB_MOBILE_DOMAIN,
  COMMUNITIES_SERVER_URL,
  GOKOLLAB_SERVER_URL,
  COMMUNITIES_SOCKETS_SERVER_URL,
  CLIENTPORTAL_SERVER_URL,
  MEMBERSHIPS_SERVER_URL,
  CLIENTPORTAL_PREVIEW_URL,
  CLIENT_PORTAL_STORAGE_BUCKET,
  COMMUNITIES_STORAGE_BUCKET,
  COMMUNITIES_CDN_URL,
  CLIENT_PORTAL_CDN_URL,
  ASSETS_DRM_BASE_URL,
  ASSETS_DRM_PROXY_URL,
  firebase,
  paymentBaseUrl,
  testPaymentsPmcId,
  livePaymentsPmcId,
}
const override = false
const overrideConfig = {
  override: true,
}
export default override ? { ...config, ...overrideConfig } : config
